import { useEffect } from "react";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Services from "@/components/site/Services";
import About from "@/components/site/About";
import Process from "@/components/site/Process";
import ClientLogos from "@/components/site/ClientLogos";
import Testimonials from "@/components/site/Testimonials";
import FinalCTA from "@/components/site/FinalCTA";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import WhatsAppFAB from "@/components/site/WhatsAppFAB";

export default function HomePage() {
  useEffect(() => {
    const els = document.querySelectorAll(".reveal");
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <main data-testid="home-page" className="bg-[#050505] text-white">
      <Navbar />
      <Hero />
      <Marquee />
      <Services />
      <About />
      <Process />
      <ClientLogos />
      <Testimonials />
      <FinalCTA />
      <Contact />
      <Footer />
      <WhatsAppFAB />
    </main>
  );
}
